const Career = () => {
  const crList = {
    cr: [
      {
        title: "아이피나우",
        period: "2023.04 - 재직중",
      },
      {
        title: "(주)텐노드솔루션",
        period: "2022.11 - 2023.03",
      },
      {
        title: "(주)이파트",
        period: "2020.08 - 2022.10",
      },
    ],
  };
  return (
    <section id="career" className="career">
      <strong className="section_tit">
        <img src="/career.png" alt="경력 아이콘" />
        <span>경력</span>
      </strong>
      <ul>
        {crList.cr.map((cr, idx) => (
          <li key={idx} className="flex justify-between items-center py-2">
            <p className="text-lg">{cr.title}</p>
            <div className="text-sm text-zinc-300">
              <span>{cr.period}</span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Career;
